import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: ${({ theme }) => theme.spacing(3)};
  width: 100%;

  border-bottom: 1px solid ${({ theme }) => theme.palette.grey['100']};

  color: ${({ theme }) => theme.palette.grey['500']};
`;

export const IconContainer = styled.span`
  display: flex;
  align-items: center;

  height: 3.2rem;

  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const Input = styled.input`
  ${({ theme }) => typographyToCss(theme.typography.h5)};
  flex: 1;
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;

  outline: none;
  background: transparent;

  color: ${({ theme }) => theme.palette.text.primary};

  &::-webkit-input-placeholder {
    color: ${({ theme }) => rgba(theme.palette.text.primary, 0.3)};
  }

  &::-moz-placeholder {
    color: ${({ theme }) => rgba(theme.palette.text.primary, 0.3)};
  }

  &:-ms-input-placeholder {
    color: ${({ theme }) => rgba(theme.palette.text.primary, 0.3)};
  }
`;

export const SubmitButton = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.buttonSmall)};
  display: flex;
  align-items: center;

  padding: ${({ theme }) =>
    `${theme.spacing(0.5)} ${theme.spacing(1.5)} ${theme.spacing(0.5)} ${theme.spacing(2)}`};
  margin: 0;

  cursor: pointer;
  background: ${({ theme }) =>
    theme.palette.primaryExtended.opacityBackgroundBackground};
  border: none;
  border-radius: ${({ theme }) => theme.spacing(6)};

  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
`;

export const SubmitIconContainer = styled.span`
  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const ClearButton = styled.button`
  padding: 0;
  margin: 0;

  cursor: pointer;
  background: transparent;
  border: none;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: inherit;
`;
